import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
import { UtilityService } from 'services';
@Component({
  templateUrl: './checkbox.component.html'
})
export class CheckboxComponent {
  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }
  getValidationMessage(val) {
    if (val === 'required') {
      return 'This field is required.';
    }
    return 'Invalid';
  }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
}
